import { useMutation } from '@tanstack/react-query';
import { axiosGlobalInstance } from 'api/axios/global';
import { routes } from 'api/routes';

type PatchUserDetails = {
  code?: number;
  type: 'enable' | 'disable';
};

export interface TwoFactorEnableResponse {
  message: string;
  recoveryCodes: string[];
}

const patch = async (values: PatchUserDetails) => {
  const { type, ...data } = values;
  return axiosGlobalInstance.patch<TwoFactorEnableResponse>(
    `${routes['2fa']}/${type}`,
    data,
  );
};

const usePatch2Fa = () => {
  return useMutation({
    mutationFn: patch,
  });
};

export default usePatch2Fa;
